import { useSelector } from "react-redux";

import { RootState } from "../../types/Store";

const useStaticStores = <A>(selector: (state: RootState) => A): A => useSelector((state: RootState) => selector(state));

export default useStaticStores;
